import { Component, EventEmitter, Output } from '@angular/core';
import { Constants } from '@base/src/app/models/constants';
import { DialogEvent } from '@base/src/app/models/dialog-event.model';
import { QRIcon } from '@base/src/app/models/qr-icon.model';

@Component({
  selector: 'app-rendition-clear-form',
  templateUrl: './rendition-clear-form.component.html',
  styleUrls: ['./rendition-clear-form.component.scss'],
})
export class RenditionClearFormComponent {
  @Output() dialogChange: EventEmitter<DialogEvent> =
    new EventEmitter<DialogEvent>();
  value: string | undefined;

  readonly ICON_WARNING = Constants.ICONS.WARNING;
  readonly ICON_COLOR_WHITE = QRIcon.COLOR_WHITE;

  ngOnInit(): void {
    const dialogEvent = {
      isButtonActionDisabled: false,
      value: true,
    };
    this.dialogChange.emit(dialogEvent);
  }
}
